<template>
  <b-container>
    <b-row>
      <b-col sm="12" class="package-details search-summary">
        <div class="wrap-summary">
          <div class="d-flex justify-content-md-between wrap-summary-details">
            <div v-if="params.departureName">
              <span class="tag-details">Plecare:</span> <span class="name-details">{{ params.departureName }}</span>
            </div>
            <div>
              <span class="tag-details">Transport: </span>
              <span class="name-details">Propriu</span>
            </div>
            <div>
              <span class="tag-details">Destinatie: </span> <span class="name-details">{{params.resortName}}</span>
            </div>
            <div>
              <span class="tag-details">Data: </span> <span class="name-details">{{departureDate}}</span>
            </div>
            <div>
              <span class="tag-details">Nr.nopti: </span> <span class="name-details">{{duration}}</span>
            </div>
            <div v-for="(room, index) in params.rooms" :key="index">
              <span class="tag-details">Camera {{index + 1 }} - </span>
              <span>{{room.adults}} </span><span class="name-details"> adulti</span>
              <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} copii</span>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <span class="blockquote-footer"><b>Oferta generata de</b> -
              <span class="name-details"> {{userData.fname}} {{userData.lname}}</span>
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment'
import auth from '@/app/private/shared/mixins/auth'

export default {
  props: ['params'],
  mixins: [auth],
  data () {
    return {
      departureDate: this.params.checkIn
    }
  },
  computed: {
    duration () {
      return moment(this.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(this.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    }
  }
}
</script>
